import { render } from "./HeaderBar.vue?vue&type=template&id=2f0a0acd&scoped=true"
import script from "./HeaderBar.vue?vue&type=script&lang=js"
export * from "./HeaderBar.vue?vue&type=script&lang=js"

import "./HeaderBar.vue?vue&type=style&index=0&id=2f0a0acd&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0a0acd"]])

export default __exports__